var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'derby_info', params: {derbyId: _vm.derbyId}}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }